
<template>
<v-dialog v-model="dialog" fullscreen scrollable @keydown.esc="emitExit()">
    <v-card flat tile>
        <v-card-title class="important white--text primary" height="50">
            <v-icon color="white" class="mr-2" @click="emitExit()">arrow_back</v-icon>
            Place
            <v-spacer></v-spacer>
            <v-icon color="white" @click="emitExit()">close</v-icon>
        </v-card-title>
        <v-card-text class="pa-0">
            <v-tabs v-model="active" background-color="primary" slider-color="white">
                <v-tab ripple>
                    General
                </v-tab>
                <v-tab-item>
                    <im-place-general :item="place" :config="config">
                        <v-card-actions slot="actions">
                            <v-spacer></v-spacer>
                            <v-btn @click="next()">next tab</v-btn>
                        </v-card-actions>
                    </im-place-general>
                </v-tab-item>

                <v-tab ripple>
                    Meta
                </v-tab>
                <v-tab-item>
                    <im-place-meta :item="place" :config="config">
                        <v-card-actions slot="actions">
                            <v-btn @click="prev()">previous tab</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn @click="next()">next tab</v-btn>
                        </v-card-actions>
                    </im-place-meta>
                </v-tab-item>

                <v-tab ripple>
                    Photos
                </v-tab>
                <v-tab-item>
                    <im-place-photos :item="place" @addPhoto="addPhoto($event)" ref="photos">
                        <v-card-actions slot="actions">
                            <v-btn @click="prev()">previous tab</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </im-place-photos>
                </v-tab-item>
            </v-tabs>

        </v-card-text>
        <v-card-actions style="background-color: #f5f5f5;">
            <v-btn color="error" v-if='id' @click="openDeleteModal()">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading_save" @click="save()">
                Save
            </v-btn>
            <v-btn color="primary" text @click="emitExit()">
                Cancel
            </v-btn>
        </v-card-actions>

        <!--delete dialog-->
        <v-dialog v-model="delete_dialog" max-width="320">
            <v-card>
                <v-card-text>
                    Are you sure you want to delete this place?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="red" :loading="loading_delete" @click="destroy()">
                        Delete
                    </v-btn>
                    <v-btn color="primary" text @click="delete_dialog=false">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--./delete dialog -->
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from "vuex";
import defaults from "../utils/PropDefaults.js";
import IMPlaceGeneral from "./PlaceModal/General.vue";
import IMPlaceMeta from "./PlaceModal/Meta.vue";
import IMPlacePhotos from "./PlaceModal/Photos.vue";
export default {
    components: {
        "im-place-general": IMPlaceGeneral,
        "im-place-meta": IMPlaceMeta,
        "im-place-photos": IMPlacePhotos,
    },
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        id: {
            type: [Number, String],
            default: null
        }
    },

    data() {
        return {
            active: null,
            dialog_photo_modal: false,
            loading_save: false,
            loading_delete: false,
            // start upload photos + show photos
            photos: [],
            dialog_photo: false,
            // end upload photos + show photos
            parent: {},
            child: {},
            check_parent: false,

            place: this.$clone(defaults.place_item),
            // set default location and viewport to Bucharest

            config: {
                place_types: [],
                timezones: [],
                languages: [],
                countries: [],
                currencies: []
            },

            delete_dialog: false,

            //props
            items: [],
            delete_place: {},

        };
    },

    created() {
        this.getConfig();
        this.getItem();
    },

    watch: {
        id: {
            handler() {
                if(!!this.id) {
                    this.getItem();
                } else {
                    this.place = this.$clone(defaults.place_item)
                }
            }
        },
        dialog: {
            handler() {
                if(this.dialog == false) {
                    this.place = this.$clone(defaults.place_item);
                }
            }
        },


    },

    methods: {
        emitClick() {
            this.$emit("click");
        },
        ...mapActions("alert", ["success", "error"]),

        next() {
            const active = parseInt(this.active)
            this.active = (active < 2 ? active + 1 : 0)
        },

        prev() {
            const active = parseInt(this.active)
            this.active = (active < 3 ? active - 1 : 0)
        },

        getConfig() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/config";

            this.$axios.get(endpoint)
                .then(response => {
                    this.config = response.data;
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getItem() {
            if(!this.id) {
                return;
            }
            // we are currently loading
            this.loading = true;

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            let geometry = null;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/places";
            let params = {
                params: {
                    with: ["parents", "children"]
                }
            };

            this.$axios.get(endpoint + "/" + this.id, params)
                .then(async response => {
                    let item = response.data;
                    if(!response.data.geometry) {
                        geometry = await this.getGeometry(response.data.id);
                        item.geometry = geometry;
                        this.place = this.$clone(item);
                    } else {
                        this.place = this.$clone(item);
                    }
                    if(response.data.meta === null) {
                        this.place.meta = this.$clone(defaults.place_item.meta);
                    }
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getGeometry(id) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/place";


            return this.$axios.get(endpoint + "/" + id)
                .then(response => {
                    return new Promise(function (resolve, reject) {
                        resolve(response.data.geometry);
                    });
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },




        save() {

            // if(this.place.parents.length == 0) {
            //     this.error("Need parent!");
            //     this.check_parent = true;
            //     return;
            // }

            let parents = [];
            this.place.parents.forEach(function (item, index) {
                parents.push(item.id);
            });

            let children = [];
            this.place.children.forEach(function (item, index) {
                children.push(item.id);
            });
            let item = this.$clone(this.place);
            item.children = children;
            item.parents = parents;

            item.priority = Number(this.place.priority);
            // return
            // we are loading
            this.loading_save = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/places";

            if(!this.place.id) {
                this.$axios.post(endpoint, item)
                    .then(response => {
                        if(this.new_photos[0]) {
                            this.savePhoto(0, response.id);
                        }
                        // this.getItems();
                        this.success("Place created.");
                        this.$emit('refresh');
                        this.emitExit();
                    })
                    .catch(error => {
                        this.error("Oops, something went wrong!");
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            } else {
                this.$axios.put(endpoint + "/" + this.place.id, item)
                    .then(response => {
                        if(this.new_photos[0]) {
                            this.savePhoto(0, this.place.id);
                        }
                        this.$emit('refresh');
                        this.success("Place edited.");
                        this.emitExit();
                    })
                    .catch(error => {
                        this.error("Oops, something went wrong!");
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            }
        },

        savePhoto(index, place_id) {

            delete this.new_photos[index].id;
            this.new_photos[index].place_id = place_id;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/destinations/photos";

            let photo = this.new_photos[index];

            setTimeout(() => {
                this.$axios.post(endpoint, {
                    place_id: photo.place_id,
                    photo: photo.photo,
                    title: photo.title,
                    description: photo.description,
                    order: photo.order,
                    status: photo.status
                })
                    .then(response => {
                        this.success("Poza a fost adaugata!");
                    })
                    .catch(error => {
                        console.log(error);
                        this.error("A aparut o eroare!");
                    })
                    .finally(() => {
                        if(index < this.photos.length - 1) {
                            this.new_photos(index + 1, place_id);
                        } else {
                            this.new_photos = [];
                            this.loading_save = false;
                        }
                    });
            }, 1000);
        },

        openDeleteModal() {
            this.delete_place_id = this.place.id;
            this.delete_dialog = true;
        },

        destroy() {
            this.loading_delete = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/places";

            // call delete endpoint
            this.$axios.delete(endpoint + "/" + this.delete_place_id)
                .then(response => {
                    this.success("Place was deleted.");
                    this.$emit('refresh');
                    this.delete_dialog = false;
                    this.emitExit();
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {
                    this.loading_delete = false;
                });
        },

        addPhoto(value) {
            this.new_photos = value;
        },

        emitExit() {
            this.$emit('exit');
            this.place = this.$clone(defaults.place_item);
            this.$refs.photos.clearPhotos();
        }
    }
};
</script>

<style>

</style>
